import React from "react";
import star from "../../assets/alltarotcards/star.jpg";
import CommonNavbar from "../CommonNavbar";
import { Link, useNavigate } from "react-router";
import { FaChevronRight, FaHome } from "react-icons/fa";
import Footer from "../../home/Footer";
import Queryform from "../Queryform";
import Navbar from "../../home/Navbar";

const StarLovers = () => {
    const navigate = useNavigate();
    const buttonClick = () => {
        navigate('/lovepotential/tarot');
    }
    return (
        <>
        <section className='bg-gradient-to-r from-white to-success/40 text-gray-900 min-h-screen'>
            <div>
                <Navbar />
            </div>
            <div className='text-gray-900 flex flex-col items-center mt-12'>
                <h1 className='text-3xl font-serif text-secondary text-center font-bold mb-2'>LOVE POTENTIAL TAROT</h1>
            </div>
            <div className="w-full max-w-3xl text-sm text-gray-600 flex flex-wrap justify-center sm:justify-start items-center mt-6 px-4 sm:px-8">
                <Link to={'/'}>
                    <FaHome className="mr-2 text-gray-700" />
                </Link>
                <Link to={'/tarot'} className="text-secondary hover:underline">TAROT</Link>
                <FaChevronRight className="mx-2" />
                <Link to={'/lovepotential/tarot'} className="text-secondary hover:underline">LOVE POTENTIAL TAROT</Link>
                <FaChevronRight className="mx-2" />
                <span className="text-gray-700 font-semibold">STAR CARD</span>
            </div>
            <main className="flex items-center mt-10 justify-center text-center">
                <div className="max-w-5xl w-full flex flex-col items-center justify-center text-center lg:flex-row gap-8">
                    {/* Card Section */}
                    <div className="flex flex-col shadow-md items-center lg:items-start">
                        <div className=" rounded-lg p-6 bg-transparent flex flex-col items-center w-80">
                            <div className="relative">
                                {/* Tarot Card Image */}
                                <img
                                    src={star}
                                    alt="The World Tarot Card"
                                    className="w-full h-auto object-cover"
                                />
                                {/* Title at the bottom of the card */}
                                <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 text-center text-primary font-bold text-lg">
                                    THE STAR
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Description Section */}
                    <div className="flex-1">
                        <h2 className="text-2xl font-bold mb-4">The STAR</h2>
                        <p className="text-gray-600 mb-6 mx-2 text-justify leading-relaxed">
                        The Star card offers hope and healing. It suggests that the relationship holds great potential for emotional fulfillment, peace, and hope. If both partners remain optimistic and aligned, this love can grow into something truly beautiful and healing. By nurturing each other's dreams and supporting one another, the relationship can provide a sense of security and happiness.
                        </p>
                        <div className="mb-6">
                            <p className="text-sm text-gray-500">
                                Learn more about Tarot
                                <a href="/learn" className="text-blue-500 ml-1 underline">
                                    Click here.
                                </a>
                            </p>
                        </div>
                        {/* Button */}
                        <button onClick={buttonClick} className="bg-gray-900 text-white py-2 px-20 rounded-lg font-semibold shadow-md hover:bg-secondary transition duration-300">
                            Pick Another Card
                        </button>
                    </div>
                </div>
            </main>
            <Queryform />
            <Footer />
        </section>
    </>
    )
}

export default StarLovers